(function(angular){
	'use strict';
	
	angular
		.module('emailEntryUnsubscribeModule')
		.controller('EmailEntryUnsubscribe', [
			'globalConfig',
			EmailEntryUnsubscribeFunction
		]);
	
	function EmailEntryUnsubscribeFunction(
		globalConfig
	){
		var emailEntryUnsubscribe = this;

		emailEntryUnsubscribe.$onInit = function() {
			emailEntryUnsubscribe = angular.extend(emailEntryUnsubscribe, globalConfig);
		};
	}
})(window.angular);